<template>
<div class="userArchivesPage">
    <div class="userArchivesCon">
        <div class="noPrintModel"></div>
        <div class="tableHeaderTit">
            <h2>公安机关人民警察训练登记表</h2>
        </div>
        <table>
            <tr>
                <td>培训登记号</td>
                <td colspan="4">{{trainInfo.code}}</td>
                <td style="width: 150px;" rowspan="5">
                    <img class="userImg" :src="trainInfo.photo" alt="">
                </td>
            </tr>
            <tr style="height:50px;">
                <td>姓名</td>
                <td style="padding: 0px;" colspan="4">
                    <table class="nested-table">
                        <tr style="height:50px;">
                            <td style="border-right: 1px solid #000;flex: 1;" colspan="2">{{trainInfo.name}}</td>
                            <td style="border-right: 1px solid #000;width: 50px;">性别</td>
                            <td style="width: 80px;">{{trainInfo.sex}}</td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td>身份证号码</td>
                <td style="padding: 0px;" colspan="4">
                    <table class="nested-table">
                        <tr style="height:50px;">
                            <td style="border-right: 1px solid #000;flex: 1;" colspan="2">{{trainInfo.idCard}}</td>
                            <td style="border-right: 1px solid #000;width: 50px;">民族</td>
                            <td style="width: 80px;">{{trainInfo.ethic}}</td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td>警衔</td>
                <td style="padding: 0px;" colspan="4">
                    <table class="nested-table">
                        <tr style="height:50px;">
                            <td style="border-right: 1px solid #000;flex: 1;" colspan="2">{{trainInfo.ranks}}</td>
                            <td style="border-right: 1px solid #000;width: 50px;">职务</td>
                            <td style="width: 80px;">{{trainInfo.zwmc}}</td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td>工作单位</td>
                <td colspan="4">{{trainInfo.unit}}</td>
            </tr>
            <tr>
                <td>培训班名称</td>
                <td colspan="5">{{trainInfo.title}}</td>
            </tr>
            <tr>
                <td>培训时间</td>
                <td colspan="5">{{trainInfo.starTime}}至{{trainInfo.endTime}}</td>
            </tr>
            <tr style="min-height: 35px;">
                <td>训练科目</td>
                <td class="dynamicList" colspan="5">
                    <div class="dynamicCon">
                        <div v-for="(item,index) in subjectList" :key="index">{{ item.name }}</div>
                    </div>
                </td>
            </tr>
            <tr style="min-height: 35px;">
                <td>考试成绩</td>
                <td class="dynamicList" colspan="5">
                    <div class="dynamicCon">
                        <div v-for="(item,index) in subjectList" :key="index">{{ item.score }}</div>
                    </div>
                </td>
            </tr>
            <tr style="height: 160px;">
                <td class="oneMesConModel" colspan="6">
                    <div class="twoTit">培训班鉴定：</div>
                    <div class="msgCon">{{trainInfo.idea1}}</div>

                    <div class="personText">
                        <span>负责人：{{trainInfo.linkman}}</span>
                        <div>{{trainInfo.time1}}</div>
                    </div>
                </td>
            </tr>
            <tr style="height: 230px;">
                <td class="twoMesConModel" colspan="6">
                    <div class="twoTit">训练单位意见：</div>
                    <div class="msgCon">{{trainInfo.idea2}}</div>

                    <div class="personText">
                        <div>{{trainInfo.time2}}</div>
                    </div>
                    <img v-if="trainInfo.sealsrc1" class="sealImgBox" :src="trainInfo.sealsrc1" alt="">
                </td>
            </tr>
            <tr v-if="trainInfo.idea3" style="height: 230px;">
                <td class="threeMesConModel" colspan="6">
                    <div class="twoTit">省级政工部门意见：</div>
                    <div class="msgCon">{{trainInfo.idea3}}</div>
                    
                    <div class="personText">
                        <div>{{trainInfo.time3}}</div>
                    </div>
                    <img v-if="trainInfo.sealsrc2" class="sealImgBox" :src="trainInfo.sealsrc2" alt="">
                </td>
            </tr>
        </table>
        <div class="noPrintModel"></div>
    </div>
</div>
</template>

<script>
import {
    getSubjectApi,
    getTrainingInfoApi
} from '@/api/train/index';
export default {
    name: 'userArchives',
    data(){
        return {
            subjectList: [],
            trainInfo:{},
        }
    },
    created(){
        this.getSubjectList();
        this.getTrainInfo();
    },
    methods:{
        //获取科目列表
        getSubjectList(){
            this.subjectList = [];
            let para = {
                trainId: this.$route.query.trainId,
                userId: this.$route.query.userId,
            };
            getSubjectApi(para).then(res=>{
                if(res.code == 200 && res.result){
                    let obj = res.result[0];
                    let names = Object.keys(obj);
                    names.forEach(itemName=>{
                        let newObj = {};
                        newObj.name = itemName;
                        newObj.score = obj[itemName];
                        this.subjectList.push(newObj);
                    })
                }
            })
        },
        //获取训历详情
        getTrainInfo(){
            let para = {
                trainId: this.$route.query.trainId,
                id: this.$route.query.userId,
            };
            getTrainingInfoApi(para).then(res=>{
                if(res.code == 200){
                    this.trainInfo = this.toLowerCaseKeys(res.result);
                }
            })
        },
        //首字母转小写
        toLowerCaseKeys(obj){
            const newObj = {};
            if(!obj){
                return newObj
            }
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                // 将每个单词的首字母转换为小写
                const lowerCaseKey = key.replace(/\b(\w)/g, s => s.toLowerCase());
                newObj[lowerCaseKey] = obj[key];
                }
            }
            return newObj;
        }
    }
}
</script>

<style lang="less" scoped>
.userArchivesPage{
    font-family: '宋体';
    color:#000;
    font-size: 16px;
    .userArchivesCon{
        width: 190.5mm;
        height: 247mm;
        margin: auto;

        .tableHeaderTit{
            text-align: center;
            margin: 0px 0px 10px 0px;
            h2{
                font-size: 20px;
            }
        }

        table {
            width: 100%;
            box-sizing: border-box;
            background-color: #fff;
            border-collapse: collapse;

            .userImg{
                height: 200px;
                width: 150px;
            }

            th, td {
                border: 1px solid #000;
                padding: 8px;
                text-align: left;
            }

            .nested-table{
                padding: 0px;
                tr{
                    display: flex;
                    padding: 0px;
                }
                th, td {
                    border: none;
                    display: flex;
                    align-items: center;
                }
            }

            .oneMesConModel,.twoMesConModel,.threeMesConModel{
                vertical-align: top;
                position: relative;

                .personText{
                    line-height: 26px;
                    position: absolute;
                    bottom: 10px;
                    right: 70px;
                    text-align: right;
                }

                .twoTit{
                    line-height: 26px;
                }
                .msgCon{
                    line-height: 26px;
                    text-indent: 1.5em;
                }

                .sealImgBox{
                    height: 150px;
                    width: 150px;
                    position: absolute;
                    right: 40px;
                    bottom: 45px;
                }
            }
            .twoMesConModel{
                
            }
            .threeMesConModel{
                
            }

            .dynamicList{
                padding: 0px;
                .dynamicCon{
                    display: flex;
                    align-items: stretch;
                    &>div{
                        flex: 1;
                        min-height: 35px;
                        line-height: 35px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #000;
                    }
                    &>div:last-child{
                        border-right: 0px;
                    }
                }
            }
        }
    }
}

.noPrintModel{
    height: 20px;
}
@media print {
    @page {
        size: 210mm 297mm; /* or size: 794px 1123px; */
    }
    .noPrintModel{
        display: none;
    }

    .tableHeaderTit h2{
        margin-top: 0px;
    }
}
</style>